import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Affix } from "antd"
import ChapterHeader from './ChapterHeader';
import SettingPane from './SettingPane';
import ChapterPane from './ChapterPane';
import ExamPane from "./ExamPane"
import TimePane from "./TimePane";
import Sheet from "./Sheet";
export class Chapter extends Component {
  static propTypes = {
    quesStore: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    ExamModel: 0//0-练习模式 1-考试模式
  }
  componentWillMount() {
    let { name } = this.props.match.params;
    if (name === 'prac') {
      //练习模式
      let config = JSON.parse(localStorage.getItem("chapterPracConfig"));
      this.props.actions.fetchQuesCreateChapter(config);
      this.setState({
        ExamModel: 0,
      })
    } else if (name === 'exam') {
      //考试模式
      let config = JSON.parse(localStorage.getItem("chapterExamConfig"));
      this.props.actions.fetchQuesCreateChapter(config);
      this.setState({
        ExamModel: 1,
      })
    } else if (name === 'check') {
      //查看模式
      let { search } = this.props.location;
      search = search.replace('?', '').split('&');

      let params = {
        busId: search[0].split('=')[1],
        resultId: search[1].split('=')[1]
      }
      this.props.actions.fetchGetQuesChapter(params);
      this.props.actions.updateCheckAllPars({ payload: true });
      this.setState({
        ExamModel: 1,
      })
    } else {
      //继续模式
      let { search } = this.props.location;
      search = search.replace('?', '').split('&');
      let params = {
        ID: search[0].split('=')[1],
      }
      this.props.actions.fetchQuesContinueChapter(params);
      this.setState({
        ExamModel: 1,
      })
    }
  }
  componentWillUnmount() {
    this.props.actions.updateCheckAllPars({ payload: false });
  }
  render() {
    const { ExamModel } = this.state;
    return (
      <div className="ques-store-chapter">
        <ChapterHeader ExamModel={ExamModel} />
        <div className="panes">
          <div className="left">
            {ExamModel === 0 && <ChapterPane />}
            {ExamModel === 1 && <ExamPane />}
          </div>
          <div className="right">
            <SettingPane />
            <Affix offsetTop={30}>
              {ExamModel === 1 && <TimePane />}
              <Sheet ExamModel={ExamModel} />
            </Affix>
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    quesStore: state.quesStore,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Chapter);



// WEBPACK FOOTER //
// ./src/features/ques-store/Chapter.js